<template>
    <div class="chat-log" v-chat-scroll>
        <chat-message v-for="(message, index) in messages" :key="index" :message="message" :user_id="user_id"></chat-message>
        <div class="empty" v-show="messages.length === 0">
            Nothing here yet!
        </div>
    </div>
</template>

<script>
    export default {
        props: ['user_id', 'messages'],
    }
</script>

<style lang="scss" scoped>
.chat-log {
    height: 80vh;
    overflow-y: scroll;
}
.chat-log .chat-message:nth-child(even){
    background-color: #ccc;
}
.empty {
    padding: 1rem;
    text-align: center;
}
</style>